import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring", "collatedPdf"],
  payload => payload
);
